import './DebtHistoryModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

export default function DebtHistoryModal({ visible, onClose, history, provider }) {
    if (!visible) return null;

    return (
        <div className="modal-overlay-debt-history">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>{provider.name}</h2>
                    <div className="modal-header-info">
                        <span className="modal-total">Total pagado: ${provider.totalPaid.toLocaleString()}</span>
                        <span className={`status-badge ${provider.status === 'deuda' ? 'mora' : 'aldia'}`}>{provider.status === 'deuda' ? 'En mora' : 'Al día'}</span>
                    </div>
                </div>

                <div className="modal-body">
                    {history.length === 0 ? (
                        <p className="empty">Sin movimientos registrados.</p>
                    ) : (
                        history.map((item, idx) => (
                            <div key={idx} className="history-item">
                                <div className="history-left">
                                    <div className="history-date">{item.date}</div>
                                    <div className="history-type">
                                        {item.type === 'Deuda nueva' && item.description ? item.description : item.type}
                                    </div>
                                </div>
                                <div className="history-right">
                                    <span className={`history-status ${item.status.toLowerCase()}`}>{item.status}</span>
                                    <span className="history-amount">${item.amount.toLocaleString()}</span>
                                </div>
                                <div className="history-actions">
                                    {idx === 0 ? (
                                        <button className="delete-btn" title='Anular movimiento'>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    ) : (
                                        <span></span>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>

                <div className="modal-footer">
                    <button onClick={onClose} className="close-btn">Cerrar</button>
                    <button onClick={() => window.location.href = '/movimientos'} className="close-btn registrar">Registrar movimiento</button>
                </div>
            </div>
        </div>
    );
}
